import HttpHelper from "../helper";

export const userPointsEndpoints = {
  getPoints: (params,signal) =>
    HttpHelper.baseAxios
      .get(`/quiz/user/points`,{params,signal})
      .then((res) => res?.data)
      .catch((err) => err?.response?.data),
};